import InvoiceService from '../services/invoice.service';
import { Invoice, InvoiceLine, Product } from './models/models';

export default {
  namespaced: true,
  state: {
    isFooterNoteModalOpen: false,
    isSendInvoiceModalOpen: null,
    invoiceId: null,
    totalInvoices: null,
    isLineModalOpen: false,
    isNotesModalOpen: false,
    isInvoiceNoModalOpen: false,
    isDatesModalOpen: false,
    invoiceLineId: null,
    query: {
      filters: {},
      sort: [],
      page: 1,
      limit: 30,
    },
    dates: {
      from: null,
      to: null,
    },
  },
  mutations: {
    invoiceId(state, invoiceId) {
      state.invoiceId = invoiceId;
    },
    isFooterNoteModalOpen(state, isFooterNoteModalOpen) {
      state.isFooterNoteModalOpen = isFooterNoteModalOpen;
    },
    isLineModalOpen(state, isLineModalOpen) {
      state.isLineModalOpen = isLineModalOpen;
    },
    isInvoiceNoModalOpen(state, isInvoiceNoModalOpen) {
      state.isInvoiceNoModalOpen = isInvoiceNoModalOpen;
    },
    isDatesModalOpen(state, isDatesModalOpen) {
      state.isDatesModalOpen = isDatesModalOpen;
    },
    isNotesModalOpen(state, isNotesModalOpen) {
      state.isNotesModalOpen = isNotesModalOpen;
    },
    invoiceLineId(state, invoiceLineId) {
      state.invoiceLineId = invoiceLineId;
    },
    totalInvoices(state, totalInvoices) {
      state.totalInvoices = totalInvoices;
    },
    queryProps(state, props) {
      state.query = Object.assign({}, state.query, props);
    },
    dateProps(state, props) {
      state.dates = Object.assign({}, state.dates, props);
    },
    isSendInvoiceModalOpen(state, isSendInvoiceModalOpen) {
      state.isSendInvoiceModalOpen = isSendInvoiceModalOpen;
    },
  },
  actions: {
    init() {
    },
    newInvoice({ commit }) {
      Invoice.new()
        .then((invoice) => {
          commit('invoiceId', invoice.id);
        });
    },
    updateInvoiceProps({ state }, props) {
      Invoice.update({
        where: state.invoiceId,
        data: props,
      });
    },
    updateInvoiceLineProps({ state }, props) {
      if (props.hasOwnProperty('product')) {
        Product.insert({ data: props.product });
      }

      InvoiceLine.update({
        where: state.invoiceLineId,
        data: props,
      });
    },
    openLineModal({ commit }, id) {
      commit('invoiceLineId', id);
      commit('isLineModalOpen', true);
    },
    deleteInvoiceLine({ state }) {
      InvoiceLine.delete(state.invoiceLineId);
    },
    getInvoices({ commit, state }) {
      const invoiceProps = state.query;
      invoiceProps.dates = state.dates;
      return InvoiceService.getInvoices(state.query)
        .then((res) => {
          commit('totalInvoices', res.total);
          Invoice.create({
            data: res.data,
            insertOrUpdate: ['currencies', 'orders', 'companies', 'users', 'products'],
          });
        });
    },
    getInvoice({ commit }, id) {
      return InvoiceService.getInvoice(id)
        .then((invoice) => {
          Invoice.create({ data: [invoice] })
            .then(() => {
              commit('invoiceId', invoice.id);
            });
        });
    },
    getInvoicePdf(store, id) {
      return InvoiceService.getInvoicePdf(id);
    },
    sendInvoice({ state }, params) {
      return InvoiceService.sendInvoice(state.invoiceId, params)
        .then((res) => {
          Invoice.insertOrUpdate({
            data: res.invoice,
          });
          return res;
        });
    },
    createInvoice({ getters }) {
      return InvoiceService.createInvoice(getters.invoice);
    },
    updateInvoice({ getters, dispatch }) {
      return InvoiceService.updateInvoice(getters.invoice)
        .then((res) => {
          if (res.hasOwnProperty('invoice_id')) {
            dispatch('getInvoice', res.invoice_id);
          }
          return res;
        });
    },
    deleteInvoice({ getters }) {
      return InvoiceService.deleteInvoice(getters.invoice)
        .then((res) => {
          if (res.hasOwnProperty('invoice_id')) {
            Invoice.delete(res.invoice_id);
          }
          return res;
        });
    },
  },
  getters: {
    invoices() {
      return Invoice.query()
        .with(['client_company', 'order', 'vessel'])
        .get();
    },
    invoice(state) {
      if (!state.invoiceId) {
        return null;
      }
      return Invoice.query()
        .withAllRecursive()
        .find(state.invoiceId);
    },
    totalAmount(state, getters) {
      if (!state.invoiceId) {
        return null;
      }
      let totalCost = 0;
      getters.invoice.invoice_lines.forEach((invoiceLine) => {
        const quantity = invoiceLine.quantity ? invoiceLine.quantity : 1;
        totalCost += quantity * invoiceLine.price;
      });
      return totalCost;
    },
    invoiceLine(state) {
      return InvoiceLine.query()
        .withAllRecursive()
        .where('id', state.invoiceLineId)
        .first();
    },
  },
};
